import {PhaseDto} from 'lib/dtos/PhaseDto';
import {PhaseStatus} from './OrderDetails';

export function getStatus(phases: PhaseDto[], index: number): PhaseStatus {
    const firstIncompleteIndex = phases.findIndex((phase) => phase.completed === false);
    if (firstIncompleteIndex === index) return 'active';
    if (phases[index].completed) return 'done';
    return 'coming';
}
